import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sendNewPassword } from "../../../service-layer/EmailService";
import Navbar from "../../components/NavBar";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  const email = query.get("email");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage("it");

    if (!token || !email) {
      navigate("/login");
    }
  }, [token, email, navigate, i18n]);

  const validatePasswordsMatch = () => {
    return newPassword === repeatPassword;
  };

  const validatePasswordStrength = (password) => {
    const minLength = /.{8,}/;
    const hasUpperCase = /[A-Z]/;
    const hasLowerCase = /[a-z]/;
    const hasDigit = /\d/;
    const hasSpecialChar = /[!@#$%^&*]/;

    return (
      minLength.test(password) &&
      hasUpperCase.test(password) &&
      hasLowerCase.test(password) &&
      hasDigit.test(password) &&
      hasSpecialChar.test(password)
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    if (newPassword.trim() === "" || repeatPassword.trim() === "") {
      alert(t("fill_required_fields"));
      return;
    }

    if (!validatePasswordStrength(newPassword)) {
      alert(t("password_not_secure"));
      return;
    }

    if (!validatePasswordsMatch()) {
      alert(t("passwords_do_not_match"));
      return;
    }

    try {
      const response = await sendNewPassword(email, token, newPassword);
      console.log(response);
      if (response === "Password reset successfully.") {
        alert(t("password_reset_successfully"));
      } else if (response === "Token has expired.") {
        alert(t("token_has_expired"));
      } else {
        alert(t("invalid_token"));
      }
      navigate("/login");
    } catch (error) {
      console.error(error);
      alert(t("an_error_occurred"));
    }
  };

  return (
    <div className="d-flex">
      <div
        style={{
          flex: "1 1 auto",
          display: "flex",
          flexFlow: "column",
          height: "100vh",
          overflowY: "hidden",
        }}
      >
        <Navbar />
        <div style={{ height: "100%" }}>
          <div className="login-container">
            <div className={`form-container signup`}>
              <form className="form" onSubmit={handleSubmit}>
                <>
                  <h2>{t("reset_password")}</h2>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder={t("enter_new_password")}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    className={`input-field ${formSubmitted && !validatePasswordStrength(newPassword) ? "error" : ""}`}
                  />
                  {formSubmitted && !validatePasswordStrength(newPassword) && (
                    <p className="error-text">{t("password_not_secure")}</p>
                  )}
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder={t("repeat_password")}
                    value={repeatPassword}
                    onChange={(e) => setRepeatPassword(e.target.value)}
                    required
                    className={`input-field ${formSubmitted && repeatPassword !== newPassword ? "error" : ""}`}
                  />
                  {formSubmitted && repeatPassword !== newPassword && (
                    <p className="error-text">{t("passwords_do_not_match")}</p>
                  )}
                  <div className="form-button" onClick={handleSubmit}>
                    {t("reset_password")}
                  </div>
                </>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
